<template>
  <div class="view pa24" :key="i18nUpdateKey">
    <div class="view mr mb20">
      <span style="color: #8d97ad; font-size: 14px" v-if="userInfo.roleId">{{ $t('business', 'setupProcess') }}</span>
    </div>
    <el-row :gutter="24">
      <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
        <div class="d-flex align-items-center">
          <el-input v-model="searchKey" class="mb10" style="width: 240px" :placeholder="$t('business', 'memberName')" />
          <el-button class="ml10 mb10" type="primary" @click="getCorporator">{{ $t('marketing', 'search') }}</el-button>
          <!-- <el-button class="ml10 mb10">导出</el-button> -->
        </div>
        <div class="d-flex align-items-center">
          <!-- <el-button type="primary" 
                     class="mb10" 
                     v-if="userInfo.roleId && qywxSwitch && !isQywxAuth" 
                    @click="toWeChat">{{ $t('business', 'wechatAuth') }}</el-button>
          <el-button type="primary" 
                     class="mb10" 
                     v-if="userInfo.roleId && qywxSwitch && isQywxAuth">{{ $t('business', 'wechatAuthorized') }}</el-button> -->
          <el-button type="primary" class="mb10" v-if="userInfo.roleId || jurisdictionA || userInfo.main"
            @click="sectorSetup">{{ $t('business', 'sectorSetup') }}</el-button>
          <el-button type="primary" class="mb10" v-if="userInfo.roleId || jurisdictionB || userInfo.main"
            @click="AdministratorList">{{ $t('business', 'administratorList') }}</el-button>
          <el-button type="primary" class="mb10" v-if="userInfo.roleId || jurisdictionC || userInfo.main"
            @click="addEmployee">{{ $t('business', 'addEmployee') }}</el-button>
        </div>
      </el-col>
    </el-row>
    <commonTable :tableData="tableData" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage" :loading="loading" :total="total">
      <template v-slot:table>
        <el-table-column prop="jobNumber" width="60px" align="center" :label="$t('business', 'jobNumber')" />
        <el-table-column prop="name" align="center" :label="$t('business', 'memberName')" />
        <el-table-column prop="character" width="100px" align="center" :label="$t('business', 'memberRole')" />
        <el-table-column prop="departmentName" width="120px" align="center" :label="$t('business', 'department')" />
        <el-table-column prop="position" width="120px" align="center" :label="$t('business', 'position')" />
        <el-table-column prop="loginAccount" width="180px" align="center" :label="$t('business', 'loginAccount')" />
        <el-table-column prop="phone" width="180px" align="center" :label="$t('business', 'displayPhone')" />
        <el-table-column prop="email" width="180px" align="center" :label="$t('business', 'displayEmail')" show-overflow-tooltip />
        <el-table-column prop="createTime" width="160px" align="center" :label="$t('business', 'createTime')" />
        <el-table-column prop="monopolismCus" width="90px" align="center" :label="$t('customer', 'exclusiveCustomers')" />
        <el-table-column prop="dealCus" width="90px" align="center" :label="$t('customer', 'dealCustomers')" />
        <!-- <el-table-column prop="qwNum" width="90px" align="center" label="企微客户数" /> -->
        <el-table-column width="160px" align="center" :label="$t('common', 'edit')">
          <template slot-scope="scope">
            <el-button type="text" @click="edit_tap(scope.row)">{{ $t('common', 'edit') }}</el-button>
            <el-button type="text" @click="detall_tap(scope.row.jobNumber, scope.row.empId)">{{ $t('business', 'memberDetail') }}</el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <el-dialog :title="$t('business', 'editMember')" center :visible.sync="dialogVisible" :modal-append-to-body="false" width="30%">
      <el-form label-width="auto" class="ruleForm d-flex flex-column align-items-center">
        <el-form-item :label="$t('business', 'jobNumber')">
          <el-input readonly style="width: 240px" v-model="memberInfo.jobNumber"></el-input>
        </el-form-item>
        <el-form-item :label="$t('business', 'name')">
          <el-input style="width: 240px" v-model="memberInfo.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('business', 'position')">
          <el-input style="width: 240px" v-model="memberInfo.position"></el-input>
        </el-form-item>
        <el-form-item :label="$t('business', 'displayPhone')">
          <el-input maxlength="20" readonly style="width: 240px; cursor: not-allowed; background-color: #f5f7fa;" v-model="memberInfo.phone"></el-input>
        </el-form-item>
        <el-form-item :label="$t('business', 'displayEmail')">
          <el-input readonly style="width: 240px; cursor: not-allowed; background-color: #f5f7fa;" v-model="memberInfo.email"></el-input>
        </el-form-item>
        <el-form-item :label="$t('business', 'department')">
          <el-select v-model="memberInfo.departmentId" style="width: 240px" :disabled="setDepartment" :placeholder="$t('business', 'pleaseSelect')">
            <el-option v-for="(item, index) in departmentList" :key="index" :label="item.name" :value="item.departmentId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('business', 'setMemberRole')" prop="memberRole" v-if="memberInfo.userType !== 2">
          <div style="width: 240px">
            <el-radio v-model="memberInfo.userType" :label="0" :disabled="setAdministrator">{{ $t('business', 'normalMember') }}</el-radio>
            <el-radio v-model="memberInfo.userType" :label="1" :disabled="setAdministrator">{{ $t('business', 'administrator') }}</el-radio>
          </div>
        </el-form-item>
        <el-form-item :label="$t('business', 'setMemberRole')" prop="memberRole" v-else>
          <div style="width: 240px">
            <el-radio v-model="memberInfo.userType" :label="0" :disabled="memberInfo.userType == 2">{{ $t('business', 'normalMember') }}</el-radio>
            <el-radio v-model="memberInfo.userType" :label="1" :disabled="memberInfo.userType == 2">{{ $t('business', 'administrator') }}</el-radio>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('common', 'cancel') }}</el-button>
        <el-button type="primary" @click="affirm_tap">{{ $t('common', 'confirm') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增员工对话框 -->
    <el-dialog :title="$t('business', 'addEmployee')" center :visible.sync="addEmployeeVisible" :modal-append-to-body="false" width="30%">
      <el-form label-width="auto" class="ruleForm d-flex flex-column align-items-center" ref="addEmployeeForm" :model="addEmployeeForm" :rules="addEmployeeRules">
        <el-form-item :label="$t('business', 'name')" prop="name">
          <el-input style="width: 240px" v-model="addEmployeeForm.name" :placeholder="$t('business', 'pleaseEnterEmployeeName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('business', 'loginEmail')" prop="email">
          <el-input style="width: 240px" v-model="addEmployeeForm.email" :placeholder="$t('business', 'pleaseEnterEmployeeEmail')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('business', 'displayPhone')" prop="phone">
          <div class="phone-input-wrapper">
            <el-select v-model="selectedCountryCode" style="width: 80px; margin-right: 10px" @change="onCountryCodeChange">
              <el-option 
                v-for="country in countryData" 
                :key="country.code" 
                :label="country.code" 
                :value="country.code"
              >
                <span>{{ country.code }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ country.name }}</span>
              </el-option>
            </el-select>
            <el-input 
              style="width: 150px" 
              v-model="addEmployeeForm.phone" 
              :placeholder="currentCountry.placeholder"
              :maxlength="currentCountry.maxLength"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item :label="$t('business', 'department')" prop="departmentId">
          <el-select v-model="addEmployeeForm.departmentId" style="width: 240px" :placeholder="$t('business', 'pleaseSelect')" clearable>
            <el-option v-for="(item, index) in departmentList" :key="index" :label="item.name" :value="item.departmentId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('business', 'position')" prop="position">
          <el-input style="width: 240px" v-model="addEmployeeForm.position" :placeholder="$t('business', 'pleaseEnterPosition')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addEmployeeVisible = false">{{ $t('common', 'cancel') }}</el-button>
        <el-button type="primary" @click="confirmAddEmployee" :loading="addEmployeeLoading">{{ $t('common', 'confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('business', 'wechatAuth')" center :visible.sync="showWeChatCode" :modal-append-to-body="false" width="50%">
      <div class="flex-c-c flex-column" style="background:#e9eaeb;">
        <iframe :src="authUrlImg" style="width:500px;height:600px;border-width:0px"></iframe>
        <p class="mb20 cA1">{{ $t('business', 'wechatAuthTip') }}</p>
        <p class="cA1">{{ $t('business', 'wechatAuthNote') }}</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import commonTable from "@/components/common/commonTable";
import { queryPageEmployee, queryEmployee, queryPageDepartment, updateEmployee, createEmployeeAccount } from "@/api/companyManage.js";
import { authUrl, callback, qywxSetting } from "@/api/qywx.js";
import { getDataTimeSec } from "@/utils/index";
import { mapState } from 'vuex';
import i18nMixin from '@/mixins/i18nMixin';
import { getCountriesData } from "@/utils/i18n/countries";
export default {
  name: "enterpriseMember",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      tableData: [],
      departmentOptions: [],
      dialogVisible: false,
      total: 0, //总条数
      currentPage: 1, //当前页数
      queryDate: "",
      pageNum: 1,
      pageSize: 10,
      loading: false, //加载中
      searchKey: '', //关键字
      jurisdictionA: '',
      jurisdictionB: '',
      jurisdictionC: '',
      jurisdictionD: '',
      jurisdictionF: '',
      departmentList: [],
      showWeChatCode: false,//企业微信授权弹框
      memberInfo: {
        position: '',
        phone: '',
        personalWx: '',
        jobNumber: '',
        position: '',
        departmentId: '',
        userType: '',
        queryType: '', //请求类型
      },
      setAdministrator: false, // 是否可设置管理员
      setDepartment: false,// 是否可设置部门
      authUrlImg: "",
      authCode: '',
      qywxSwitch: 0,
      isQywxAuth: 0,
      // 新增员工相关
      addEmployeeVisible: false,
      addEmployeeLoading: false,
      selectedCountryCode: '+852', // 默认香港区号
      addEmployeeForm: {
        name: '',
        email: '',
        phone: '',
        departmentId: '',
        position: ''
      },
      addEmployeeRules: {
        name: [
          { required: true, message: this.$t('business', 'pleaseEnterEmployeeName'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('business', 'pleaseEnterEmployeeEmail'), trigger: 'blur' },
          { type: 'email', message: this.$t('business', 'pleaseEnterValidEmail'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: this.$t('business', 'pleaseEnterEmployeePhone'), trigger: 'blur' }
        ],
    
        position: [
          { required: true, message: this.$t('business', 'pleaseEnterPosition'), trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.authCode = this.$route.query.auth_code
    // 初始化departmentOptions，确保this.$t可用
    this.departmentOptions = [{ value: "1", lable: this.$t('business', 'normalMember') }];
  },
  computed: {
    ...mapState(['routerArr']),
    userInfo() {
      return this.$store.state.loginRoot.userInfo;
    },
    // 动态获取当前语言的国家数据
    countryData() {
      return getCountriesData(this.$store.state.currentLanguage);
    },
    // 当前选中的国家信息
    currentCountry() {
      return this.countryData.find(country => country.code === this.selectedCountryCode) || this.countryData[0];
    }
  },
  watch: {
    routerArr(val) {
      this.jurisdictionA = val.some(item => ['0210', '02100', '02101'].includes(item))//部门管理
      this.jurisdictionB = val.includes('0211')//管理员设置
      this.jurisdictionC = val.includes('0212')//成员设置
      this.jurisdictionD = val.some(item => ['02100'].includes(item))//部门管理(自己)
      this.jurisdictionF = val.some(item => ['02101'].includes(item))//部门管理(所有)      
      if (this.jurisdictionD) {
        this.queryType = 'section'
      }
      if (this.jurisdictionF) {
        this.queryType = 'all'
      }
      this.getCorporator()
    },
    jurisdictionB(val) {
      if (this.userInfo.roleId) {
        this.setAdministrator = false
      } else {
        this.setAdministrator = val ? false : true
      }
    },
    jurisdictionF(val) {
      if (this.userInfo.roleId) {
        this.setDepartment = false
      } else {
        this.setDepartment = val ? false : true
      }
    },
    authCode(val) {
      if (val) {
        this.WeChatCallback()
      }
    }
  },
  filters: {
    dateFilter(val) {
      console.log(val);
    },
  },
  mounted() {
    this.getCorporator();
    // this.qywxSetting();
  },
  methods: {
    //获取企业成员
    getCorporator(Type) {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name: this.searchKey,
        queryType: this.$store.state.loginRoot.userInfo.roleId ? 'all' : this.queryType ? this.queryType : 'single'
      }
      queryPageEmployee(data)
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.pageInfo.list;
          this.total = res.data.pageInfo.total
          this.tableData.forEach((v) => {
            v.createTime = getDataTimeSec(v.createTime);
            if (v.userType == 0) {
              v.character = this.$t('business', 'employee')
            } else if (v.userType == 1) {
              v.character = this.$t('business', 'administrator')
            } else {
              v.character = this.$t('business', 'boss')
            }
          });
        })
        .catch((err) => {
          this.tableData = []
          this.loading = false;
          console.log(err);
        });
    },
    qywxSetting() {
      qywxSetting({ ignore: true })
        .then(res => {
          if (res.success && res.code == 200 && res.data) {
            this.qywxSwitch = res.data.qywxSwitch
            this.isQywxAuth = res.data.isQywxAuth
            this.qywxSwitch && !this.isQywxAuth && this.authUrl()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    authUrl() {
      authUrl({ ignore: true })
        .then(res => {
          this.authUrlImg = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    WeChatCallback() {
      var that = this
      let data = {
        auth_code: this.$route.query.auth_code,
        state: this.$route.query.state,
        expires_in: this.$route.query.expires_in
      }
      callback(data)
        .then(res => {
          if (res.code == 200) {
            that.$router.push('/enterpriseMember')
            that.qywxSetting()
          }
        })
        .catch(err => {
        })
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.loading = true;
      this.getCorporator();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.currentPage = 1;
      this.loading = true;
      this.getCorporator();
    },
    addStr(oldStr, addItem, afterWhich) {
      // 在指定字符串后面添加指定字符串
      var strArr = oldStr.split('');
      strArr.splice(oldStr.indexOf(afterWhich) + afterWhich.length, 0, addItem);
      return strArr.join('');
    },
    //请求员工详情
    async queryEmployee(id) {
      let data = {
        empId: id
      }
      let result = await queryEmployee(data)
      if (result.data.routers) {
        console.log("result.data.routers:", result.data.routers)
        result.data.routers = JSON.parse(result.data.routers.replace(/'/g, '"'))
        console.log("result.data.routers:", result.data.routers)
      }
      this.memberInfo = result.data
    },
    //请求部门信息
    getPageDepartment() {
      let data = {
        pageSize: 999,
      };
      queryPageDepartment(data)
        .then((res) => {
          this.departmentList = res.data.pageInfo.list || "";
        })
        .catch((err) => {
          this.departmentList = [];
        });
    },
    detall_tap(id, empId) {
      this.$router.push('./memberDetall?id=' + id + '&empId=' + empId)
    },
    edit_tap(item) {
      if (!this.userInfo.roleId) {
        if (item.userType == 0) {
          if (!this.jurisdictionC) {
            return this.$message({
              message: this.$t('business', 'noPermission'),
              type: "warning",
            });
          }
        } else if (item.userType == 1) {
          if (!this.jurisdictionB) {
            return this.$message({
              message: this.$t('business', 'noPermission'),
              type: "warning",
            });
          }
        } else if (item.userType == 2) {
          return this.$message({
            message: this.$t('business', 'bossInfoCannotModify'),
            type: "warning",
          });
        }
      }
      if (this.jurisdictionC || this.userInfo.roleId) {
        this.queryEmployee(item.empId)
        this.getPageDepartment()
        this.dialogVisible = true
      } else {
        return this.$message({
          message: this.$t('business', 'noPermission'),
          type: "warning",
        });
      }
    },
    toWeChat() {
      window.location.href = this.authUrlImg
    },
    sectorSetup() {
      this.$router.push('/sectorSetup')
    },
    AdministratorList() {
      this.$router.push('/AdministratorList')
    },
    affirm_tap() {
      if (this.memberInfo.userType == 0) {
        this.memberInfo.routers = []
      } else {
        this.memberInfo.routers = this.$defaultRouters
      }
      updateEmployee(this.memberInfo)
        .then(res => {
          this.dialogVisible = false
          this.getCorporator()
        })
    },
    // 新增员工按钮点击事件
    addEmployee() {
      this.addEmployeeVisible = true;
      this.resetAddEmployeeForm();
      // 加载部门列表
      this.getPageDepartment();
    },
    // 区号改变时清空手机号
    onCountryCodeChange() {
      this.addEmployeeForm.phone = '';
    },
    // 重置新增员工表单
    resetAddEmployeeForm() {
      this.addEmployeeForm = {
        name: '',
        email: '',
        phone: '',
        departmentId: '',
        position: ''
      };
      this.selectedCountryCode = '+852'; // 重置为默认区号
      if (this.$refs.addEmployeeForm) {
        this.$refs.addEmployeeForm.clearValidate();
      }
    },
    // 确认新增员工
    async confirmAddEmployee() {
      try {
        // 表单验证
        const valid = await this.$refs.addEmployeeForm.validate();
        if (!valid) {
          return;
        }
        console.log("this.currentCountry:", this.currentCountry)
        console.log("this.addEmployeeForm.phone:", this.addEmployeeForm.phone)
        console.log("this.selectedCountryCode:", this.selectedCountryCode)
        
        // 手机号格式验证
        const phoneRegex = new RegExp(this.currentCountry.pattern);
        if (!phoneRegex.test(this.addEmployeeForm.phone)) {
          this.$message({
            message: this.currentCountry.placeholder,
            type: "warning",
          });
          return;
        }
        
        this.addEmployeeLoading = true;
        
        const apiData = {
          name: this.addEmployeeForm.name,
          email: this.addEmployeeForm.email,
          phone: this.selectedCountryCode + this.addEmployeeForm.phone,
          departmentName: this.getDepartmentNameById(this.addEmployeeForm.departmentId),
          departmentId:this.addEmployeeForm.departmentId,
          position: this.addEmployeeForm.position
        };
        
        const result = await createEmployeeAccount(apiData);
        
        if (result && result.code === 200) {
          this.$message.success(this.$t('business', 'addEmployeeSuccess'));
          this.addEmployeeVisible = false;
          this.resetAddEmployeeForm();
          this.getCorporator();
        } else {
          // 处理业务错误（如 code: 201）
          const errorMessage = result && result.message ? result.message : this.$t('business', 'addEmployeeFailed');
          this.$message.error(errorMessage);
        }
      } catch (error) {
        console.error('新增员工失败:', error);
        if (error && error.message) {
          this.$message.error(error.message);
        } else {
          this.$message.error(this.$t('business', 'addEmployeeFailed'));
        }
      } finally {
        this.addEmployeeLoading = false;
      }
    },
    // 根据部门ID获取部门名称
    getDepartmentNameById(departmentId) {
      if (!departmentId) {
        return '';
      }
      const department = this.departmentList.find(dept => dept.departmentId === departmentId);
      return department ? department.name : '';
    }
  },
  beforeDestroy() {
    // 清理表单引用，避免Element UI警告
    if (this.$refs.addEmployeeForm) {
      this.$refs.addEmployeeForm = null;
    }
    if (this.$refs.ruleForm) {
      this.$refs.ruleForm = null;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}

.phone-input-wrapper {
  display: flex;
  align-items: center;
}
</style>